import defaultLabels from './chatUiLabels.defaults.json';

export function resolveChatUiLabels(language, configuredLabels = {}) {
	const locale = String(language || '').trim().toLowerCase();
	const baseLanguage = locale.split(/[-_]/)[0];
	const configured = configuredLabels && typeof configuredLabels === 'object' ? configuredLabels : {};
	const directLabels = Object.values(configured).some(value => typeof value === 'string') ? configured : {};
	const configuredDefault = configured.default && typeof configured.default === 'object' ? configured.default : {};
	const configuredLocale = configured[locale] && typeof configured[locale] === 'object' ? configured[locale] : {};
	const configuredLanguage = configured[baseLanguage] && typeof configured[baseLanguage] === 'object'
		? configured[baseLanguage]
		: {};

	return {
		...(defaultLabels.en || {}),
		...(defaultLabels[baseLanguage] || {}),
		...configuredDefault,
		...configuredLanguage,
		...configuredLocale,
		...directLabels
	};
}
